import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import * as wjCore from "wijmo/wijmo";
import * as wjGrid from "wijmo/wijmo.grid";
import { Subscription } from "rxjs/Subscription";
import { CurrentAccountListComponent } from "@dashboard/modules/finance-management/current-account/components/current-account-list/current-account-list.component";
import { CustomerListComponent } from "@dashboard/modules/shipping-management/customer/components/customer-list/customer-list.component";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { MaterialInfoService } from "@app/modules/shared/services/material/material-info.service";
import { UuidService } from "@app/modules/shared/services/uuid.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import {
  ExplorerService,
  ModalConfig,
} from "@app/modules/shared/services/explorer.service";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { MaterialListComponent } from "@dashboard/modules/material-management/material/components/material-list/material-list.component";
import { TriggerType } from "@app/modules/shared/enum/trigger-type.enum";
import {
  VirtualOrderDto,
  VirtualOrderLinesDto,
} from "@dashboard/modules/shipping-management/virtual-order-receipt/model/virtual-order.dto";
import { PrimengLocal } from "@app/modules/shared/constants/primeng-local";
import { MaterialDto } from "@dashboard/modules/material-management/material/model/material.dto";

@Component({
  selector: "kl-virtual-order-receipt-form",
  templateUrl: "./virtual-order-receipt-form.component.html",
  styleUrls: ["./virtual-order-receipt-form.component.scss"],
})
export class VirtualOrderReceiptFormComponent implements OnInit, OnDestroy {
  @Input() entity: VirtualOrderDto = new VirtualOrderDto();
  @ViewChild("fastMaterialEntryModal", { static: true })
  private fastMaterialEntryModal: any;
  @ViewChild("focusElement", { static: true }) private elementFocus: ElementRef;
  @ViewChild("VirtualOrderReceiptForm", { static: true })
  private virtualOrderReceiptForm: any;
  @Input() isReadOnly: boolean;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  @Input() mode: string;
  title = "";
  dateFormatString: string;
  document_time: Date;
  document_date: Date;
  locale =
    PrimengLocal[
      localStorage.getItem("currentLanguage")
        ? localStorage.getItem("currentLanguage").toUpperCase()
        : "TR"
    ];
  productGroupDataMap: wjGrid.DataMap;
  packageTypeDataMap: wjGrid.DataMap;
  linesCollectionView: wjCore.CollectionView;
  lineLoading = false;
  showLineGrid = false;
  notFoundMaterial = false;
  generateCodeSpin = false;
  currentLine: any;
  currentLineRowIndex = 0;
  productGroupSource = [
    {
      value: "J_RETAIL",
      label: this.translateService.instant("J_RETAIL"),
    },
    {
      value: "KL_RETAIL",
      label: this.translateService.instant("KL_RETAIL"),
    },
    {
      value: "VENUT",
      label: this.translateService.instant("VENUT"),
    },
  ];
  packageTypeSource = [
    {
      value: "MAIN_PACKAGE",
      label: this.translateService.instant("MAIN_PACKAGE"),
    },
    {
      value: "PLUS_USER",
      label: this.translateService.instant("PLUS_USER"),
    },
    {
      value: "ADDITION_PACKAGE",
      label: this.translateService.instant("ADDITION_PACKAGE"),
    },
  ];
  alertShow: boolean;
  errorShow: boolean;
  alertMessage: string;
  curr_account_id: number;
  loading: boolean;
  subscription: Subscription;
  subscriptionUserDetail: Subscription;

  isOpenFirstAccordion = true;
  isOpenThirdAccordion = false;

  materialSelectOnLine = {
    method: (cell) => {
      let prefix = "VIRTUAL_ORDER_RECEIPT_";
      prefix = prefix + (this.mode === "edit" ? this.entity.id + "" : "");
      const modalConfig = <ModalConfig>{
        title: "material",
        stateSelector: prefix + "MATERIAL_GRID",
        childTemplate: <DynamicComponent>{
          mode: "DIALOG",
          modalId: "01.02.01",
          dblSelect: true,
          template: MaterialListComponent,
          templateContext: {
            textToFilter: cell.item.material.code
              ? cell.item.material.code
              : "",
            filter: {
              status: "ACTIVE",
              package_types: [cell.item.package_type],
              product_groups: [cell.item.product_group],
              code: cell.item.material.code ? cell.item.material.code : "",
            },
            parameters: [
              {
                name: "code",
                expression: {
                  operator: "EQ",
                },
              },
            ],
            query: {
              paging: {
                limit: 1,
                fetch: "EAGER",
              },
            },
            document_type: this.entity.document_type,
          },
          trigger_type: TriggerType.MATERIAL_RECEIPT,
        },
      };
      this.explorerService.openModal(modalConfig);
      this.currentLine = cell.item;
      this.currentLineRowIndex = cell.row.index;
    },
  };
  CurrentAccountList = CurrentAccountListComponent;
  CustomerList = CustomerListComponent;

  constructor(
    private toastService: ToastService,
    private alertService: KlSweetAlertService,
    private apiService: ApiService,
    private projectionService: MaterialInfoService,
    private uuidService: UuidService,
    private utilService: UtilService,
    private klAlertService: KlAlertService,
    private translateService: TranslateService,
    private klLoadingService: KlLoadingService,
    private explorerService: ExplorerService
  ) {
    this.dateFormatString = UtilService.dateFormatString
      .toLowerCase()
      .replace("yy", "");
    this.subscription = explorerService.transferState$.subscribe((state) => {
      this.formChange(true);
      let prefix = "VIRTUAL_ORDER_RECEIPT_";
      prefix = prefix + (this.mode === "edit" ? this.entity.id + "" : "");
      switch (state.state) {
        case prefix + "CURRENT_ACCOUNT_CURRENT_ITEM":
          this.entity.current_account = state.payload;
          break;
        case prefix + "CUSTOMER_CURRENT_ITEM":
          this.entity.customer = state.payload;
          break;
        case prefix + "MATERIAL_GRID_CURRENT_ITEM":
          this.setSelectedValueOnLine(state.payload);
          break;
        case prefix + "MATERIAL_GRID_CURRENT_ITEM_CONTINUE":
          this.setSelectedValueOnLine(state.payload, true);
          break;
      }
    });
    this.subscriptionUserDetail = explorerService.userStream$.subscribe(
      (userDetail) => {
        if (userDetail) {
          this.curr_account_id = userDetail.curr_account_id;
        }
      }
    );
  }

  lineSourceDto(): VirtualOrderLinesDto {
    const dto = new Array({
      external_id: UtilService.createGUID(),
      rec_status: "NEW",
      product_group: this.productGroupSource[0].value,
      package_type: this.packageTypeSource[0].value,
      material: {},
      quantity: 0,
      user_count: 0,
    });
    return dto[0];
  }

  openLineAccordion(event) {
    this.isOpenThirdAccordion = event;
    if (!this.showLineGrid) {
      this.showLineGrid = true;
    }
    if (event) {
      this.linesCollectionView.refresh();
    }
  }

  formChange(event) {
    if (this.tabId) {
      this.explorerService.changeFormStatus({
        tabId: this.tabId,
        changeForm: event,
      });
    }
  }

  ngOnInit() {
    this.packageTypeDataMap = new wjGrid.DataMap(
      this.packageTypeSource,
      "value",
      "label"
    );
    this.productGroupDataMap = new wjGrid.DataMap(
      this.productGroupSource,
      "value",
      "label"
    );
    switch (this.mode) {
      case "add":
        this.addMode();
        break;
      case "copy":
        this.copyMode();
        break;
      case "view":
      case "edit":
        this.editMode();
        break;
    }
  }

  addMode() {
    if (this.entity.hasOwnProperty("type") === false) {
      this.entity.document_type = "VIRTUAL_ORDER";
    } else {
      this.entity.document_type = this.entity.type;
      delete this.entity.type;
    }
    if (this.curr_account_id) {
      this.klLoadingService.show("loading");
      this.apiService
        .getDataById("current-account", this.curr_account_id)
        .subscribe(
          (response) => {
            this.klLoadingService.hide();
            if (response === undefined) {
              this.handleError("error_data");
            } else {
              this.entity.current_account = response;
            }
          },
          (error) => this.handleError(error)
        );
    } else {
      this.klLoadingService.hide();
    }
    this.entity.virtual_order_lines = [this.lineSourceDto()];
    this.linesCollectionView = new wjCore.CollectionView(
      this.entity.virtual_order_lines
    );
    this.linesCollectionView.trackChanges = true;
    this.openLineAccordion(true);
    this.document_date = new Date();
    this.document_time = new Date();
    this.generateNumber();
    this.klLoadingService.hide();
    this.title =
      this.translateService.instant("new") +
      " " +
      this.translateService.instant(this.entity.document_type);
  }

  copyMode() {
    this.document_date = new Date();
    const dateString = this.document_date.toDateString();
    const timeString = this.document_date.toTimeString().split(" ")[0];
    this.document_time = new Date(dateString + " " + timeString);
    if (this.entity.virtual_order_lines) {
      if (this.entity.virtual_order_lines.length > 0) {
        for (let j = 0; j < this.entity.virtual_order_lines.length; j++) {
          delete this.entity.virtual_order_lines[j].id;
          Object.assign(this.entity.virtual_order_lines[j], {
            external_id: UtilService.createGUID(),
            rec_status: "NEW",
          });
        }
      } else {
        this.entity.virtual_order_lines = [this.lineSourceDto()];
      }
    } else {
      this.entity.virtual_order_lines = [this.lineSourceDto()];
    }
    this.linesCollectionView = new wjCore.CollectionView(
      this.entity.virtual_order_lines
    );
    this.linesCollectionView.trackChanges = true;
    this.openLineAccordion(true);
    this.generateNumber();
    this.klLoadingService.hide();
    this.title =
      this.translateService.instant("new") +
      " " +
      this.translateService.instant(this.entity.document_type);
  }

  editMode() {
    this.document_date = new Date(this.entity.document_date);
    const dateString = this.document_date.toDateString();
    const timeString = this.document_date.toTimeString().split(" ")[0];
    this.document_time = new Date(dateString + " " + timeString);
    if (this.entity.virtual_order_lines) {
      if (this.entity.virtual_order_lines.length > 0) {
        for (let j = 0; j < this.entity.virtual_order_lines.length; j++) {
          Object.assign(this.entity.virtual_order_lines[j], {
            external_id: UtilService.createGUID(),
          });
        }
      } else {
        this.entity.virtual_order_lines = [this.lineSourceDto()];
      }
    } else {
      this.entity.virtual_order_lines = [this.lineSourceDto()];
    }
    this.linesCollectionView = new wjCore.CollectionView(
      this.entity.virtual_order_lines
    );
    this.linesCollectionView.trackChanges = true;
    this.openLineAccordion(true);
    this.klLoadingService.hide();
    this.title =
      this.translateService.instant(this.entity.document_type) + " - ";
  }

  generateNumber() {
    this.generateCodeSpin = true;
    const codeObject = {
      document_type: this.entity.document_type,
    };
    this.apiService
      .addData("virtual-order/generatenumber", codeObject)
      .finally(() => {
        this.klLoadingService.hide();
        this.generateCodeSpin = false;
      })
      .subscribe(
        (resCode) => {
          if (resCode === undefined) {
            this.handleError("error_data");
          } else {
            this.formChange(true);
            this.entity.document_num = resCode.document_number;
            if (this.mode === "edit") {
              this.title =
                this.translateService.instant(this.entity.document_type) +
                " - ";
            }
          }
        },
        (errCode) => this.handleError(errCode)
      );
  }

  clearCurrentAccount() {
    delete this.entity.current_account;
    this.formChange(true);
  }

  clearCustomer() {
    delete this.entity.customer;
    this.formChange(true);
  }

  setModal(title: string, stateSelector: string, template: any, modalId) {
    let prefix = "VIRTUAL_ORDER_RECEIPT_";
    prefix = prefix + (this.mode === "edit" ? this.entity.id + "" : "");
    const modalConfig = <ModalConfig>{
      title: title,
      stateSelector: prefix + stateSelector,
      childTemplate: <DynamicComponent>{
        mode: "DIALOG",
        modalId: modalId,
        dblSelect: true,
        template: template,
        templateContext: {
          filter: {
            status: "ACTIVE",
          },
        },
      },
    };
    this.explorerService.openModal(modalConfig);
  }

  setSelectedValueOnLine(item, addNew = false) {
    this.lineLoading = true;
    let row: number;
    const filter = {
      filter: {
        code: item.code,
      },
      parameters: [
        {
          name: "code",
          expression: {
            operator: "EQ",
          },
        },
      ],
      query: {
        paging: {
          limit: 1,
          fetch: "EAGER",
        },
      },
    };
    this.apiService.getFilteredData("material", filter, "flat").subscribe(
      (response) => {
        if (response.data === undefined) {
          this.handleError("error_data");
        } else {
          if (response.data[0]) {
            if (response.data[0].status === "ACTIVE") {
              this.lineLoading = false;
              this.notFoundMaterial = false;
              if (addNew) {
                this.notFoundMaterial = false;
                if (
                  this.linesCollectionView.sourceCollection.length === 1 &&
                  !this.linesCollectionView.sourceCollection[0].material.code
                ) {
                  this.currentLine = this.linesCollectionView
                    .sourceCollection[0]
                    ? this.linesCollectionView.sourceCollection[0]
                    : null;
                  row = 0;
                } else {
                  this.addNewLine();
                  this.currentLine =
                    this.linesCollectionView.sourceCollection[
                      this.linesCollectionView.sourceCollection.length - 1
                    ];
                  row = this.linesCollectionView.sourceCollection.length - 1;
                }
              } else {
                row = this.currentLineRowIndex;
              }
              this.setLine(this.currentLine, response.data[0], row);
            } else {
              this.lineLoading = false;
              this.handleError("product_is_closed_to_use", "errorShow");
            }
          } else {
            this.lineLoading = false;
            this.handleError("product_not_found", "errorShow");
          }
        }
      },
      () => {
        this.lineLoading = false;
        this.handleError("product_not_found", "errorShow");
      }
    );
  }

  addNewLine(flexGrid?: wjGrid.FlexGrid) {
    this.formChange(true);
    const column = this.lineSourceDto();
    this.entity.virtual_order_lines.push(column);
    this.linesCollectionView.refresh();
    if (flexGrid) {
      const lineRow = this.linesCollectionView.sourceCollection.length;
      const selectedCellRange = flexGrid.selection;
      selectedCellRange.row = lineRow - 1;
      selectedCellRange.col = 0;
      selectedCellRange.row2 = selectedCellRange.row;
      selectedCellRange.col2 = 0;
      flexGrid.select(selectedCellRange, true);
    }
  }

  deleteLine() {
    this.formChange(true);
    if (this.linesCollectionView.sourceCollection.length === 0) {
      this.addNewLine();
    }
  }

  changeLineColumn(event) {
    this.formChange(true);
    const binding = event.flexGrid.columns[event.col].binding;
    const col = event.col;
    const row = event.row;
    const flexGrid = event.flexGrid;
    const dataItem: VirtualOrderLinesDto = flexGrid.rows[row].dataItem;
    this.linesCollectionView.beginUpdate();
    this.linesCollectionView.editItem(dataItem);
    if (dataItem.id) {
      if (dataItem.hasOwnProperty("rec_status")) {
        dataItem.rec_status = "EDIT";
      } else {
        Object.assign(dataItem, { rec_status: "EDIT" });
      }
    }
    if (binding.includes("material")) {
      const code = dataItem["material"]["code"];
      if (code) {
        this.notFoundMaterial = false;
        this.lineLoading = true;
        const explodeObjectKey = flexGrid.columns[col].binding.split(".");
        const filter = {
          filter: {
            status: "ACTIVE",
            package_types: [dataItem.package_type],
            product_groups: [dataItem.product_group],
            code: dataItem[explodeObjectKey[0]][explodeObjectKey[1]],
          },
          parameters: [
            {
              name: "code",
              expression: {
                operator: "EQ",
              },
            },
            {
              name: "package_types",
              expression: {
                operator: "IN",
              },
            },
            {
              name: "product_groups",
              expression: {
                operator: "IN",
              },
            },
          ],
          query: {
            paging: {
              limit: 1,
              fetch: "EAGER",
            },
          },
        };
        this.apiService
          .getFilteredData("material", filter, "flat")
          .finally(() => (this.lineLoading = false))
          .subscribe(
            (response) => {
              if (response.data === undefined) {
                this.handleError("error_data");
              } else {
                if (response.data[0]) {
                  this.notFoundMaterial = false;
                  if (response.data[0].status === "ACTIVE") {
                    this.setLine(dataItem, response.data[0], row);
                  } else {
                    this.clearLine(flexGrid, row);
                    this.handleError("product_is_closed_to_use", "errorShow");
                  }
                } else {
                  this.handleError("product_not_found", "errorShow");
                  this.clearLine(flexGrid, row);
                }
              }
            },
            (error) => this.handleError(error)
          );
      } else {
        this.clearLine(flexGrid, row);
      }
    }
    if (binding.includes("package_type")) {
      if (dataItem.package_type === "PLUS_USER") {
        dataItem.user_count = 1;
      } else {
        dataItem.user_count = 0;
      }
    }
    this.linesCollectionView.commitEdit();
    this.linesCollectionView.endUpdate();
  }

  changeLineRow(event) {
    this.currentLineRowIndex = event.row > -1 ? event.row : 0;
  }

  editLineCell(editData) {
    const flexGrid: wjGrid.FlexGrid = editData.flexGrid;
    const event: any = editData.event;
    const col = flexGrid.columns[editData.event.col];
    if (col.binding === "user_count") {
      const collectionView = flexGrid.collectionView;
      if (collectionView.currentItem) {
        if (collectionView.currentItem["package_type"] !== "PLUS_USER") {
          event.cancel = true;
        }
      }
    }
  }

  setLine(currentItem: VirtualOrderLinesDto, responseItem: MaterialDto, row) {
    const item = currentItem;
    this.linesCollectionView.beginUpdate();
    this.linesCollectionView.editItem(item);
    if (item.id) {
      if (item.hasOwnProperty("rec_status")) {
        item.rec_status = "EDIT";
      } else {
        Object.assign(item, {
          rec_status: "EDIT",
        });
      }
    }
    item.material = {
      id: responseItem.id,
      code: responseItem.code,
      description: responseItem.description,
    };
    item.package_type = responseItem.package_type;
    item.product_group = responseItem.product_group;
    item.user_count = responseItem.user_count ? responseItem.user_count : 0;
    if (row) {
      this.currentLineRowIndex = row;
    }
    this.linesCollectionView.commitEdit();
    this.linesCollectionView.endUpdate();
  }

  clearLine(flexGrid, row) {
    const currentItem: VirtualOrderLinesDto = flexGrid.rows[row].dataItem;
    this.linesCollectionView.beginUpdate();
    this.linesCollectionView.editItem(currentItem);
    currentItem.material = {};
    currentItem.quantity = 0;
    currentItem.user_count = 0;
    currentItem.product_group = this.productGroupSource[0].value;
    currentItem.package_type = this.packageTypeSource[0].value;
    this.linesCollectionView.commitEdit();
    this.linesCollectionView.endUpdate();
    flexGrid.selection.col = 0;
    flexGrid.selection.row2 = flexGrid.selection.row;
    flexGrid.selection.col2 = 0;
    flexGrid.select(flexGrid.selection, true);
    flexGrid.startEditing(true, flexGrid.selection.row, 0, true);
  }

  clearForm() {
    this.formChange(false);
    this.alertShow = false;
    Object.keys(this.entity).forEach((key) => {
      if (key !== "document_type") {
        if (key !== "current_account") {
          delete this.entity[key];
        }
      }
    });
    this.entity.document_date = new Date();
    this.entity.virtual_order_lines = [];
    this.linesCollectionView = new wjCore.CollectionView(
      this.entity.virtual_order_lines
    );
    this.addNewLine();
    this.generateNumber();
  }

  commitSave(action: string) {
    if (
      this.virtualOrderReceiptForm.valid &&
      this.entity.customer &&
      this.entity.current_account
    ) {
      // zorunlu alanlar doldurulmuş ise
      // Satırlar set ediliyor
      for (
        let i = 0;
        i < this.linesCollectionView.sourceCollection.length;
        i++
      ) {
        if (
          this.linesCollectionView.sourceCollection[i].material.hasOwnProperty(
            "code"
          )
        ) {
          // satırlarda malzeme objesi içerisinde code property'i varsa
          if (this.linesCollectionView.sourceCollection[i].material.code) {
            // malzemenin kodu dolu ise
          } else {
            // code property'i var ama malzemenin kodu yoksa
            this.linesCollectionView.remove(
              this.linesCollectionView.sourceCollection[i]
            );
            i = i - 1;
          }
        } else {
          // malzeme objesi var ama içinde code property'i yok yani malzeme eklenmemiş satırsa
          this.linesCollectionView.remove(
            this.linesCollectionView.sourceCollection[i]
          );
          i = i - 1;
        }
      }
      // silinen satır varsa
      if (this.linesCollectionView.itemsRemoved.length > 0) {
        for (let i = 0; i < this.linesCollectionView.itemsRemoved.length; i++) {
          if (this.linesCollectionView.itemsRemoved[i].id) {
            if (this.linesCollectionView.itemsRemoved[i].serial_lots) {
              if (
                this.linesCollectionView.itemsRemoved[i].serial_lots.length > 0
              ) {
                for (
                  let l = 0;
                  l <
                  this.linesCollectionView.itemsRemoved[i].serial_lots.length;
                  l++
                ) {
                  if (
                    this.linesCollectionView.itemsRemoved[i].serial_lots[l].id
                  ) {
                    if (
                      this.linesCollectionView.itemsRemoved[i].serial_lots[l]
                        .rec_status
                    ) {
                      this.linesCollectionView.itemsRemoved[i].serial_lots[
                        l
                      ].rec_status = "DELETE";
                    } else {
                      Object.assign(
                        this.linesCollectionView.itemsRemoved[i].serial_lots[l],
                        { rec_status: "DELETE" }
                      );
                    }
                  }
                }
              }
            }
            if (this.linesCollectionView.itemsRemoved[i].rec_status) {
              this.linesCollectionView.itemsRemoved[i].rec_status = "DELETE";
            } else {
              Object.assign(this.linesCollectionView.itemsRemoved[i], {
                rec_status: "DELETE",
              });
            }
            this.entity.virtual_order_lines.push(
              this.linesCollectionView.itemsRemoved[i]
            );
          }
        }
      }
      this.alertShow = false;
      const time = this.document_time.toTimeString().split(" ");
      const date = this.document_date.toISOString().split("T");
      const newDate = new Date(date[0] + " " + time[0]);
      this.entity.document_date = newDate.getTime();
      this.klLoadingService.show("saving");
      switch (action) {
        case "SAVE":
          switch (this.mode) {
            case "add":
            case "copy":
              this.apiService.addData("virtual-order", this.entity).subscribe(
                () => this.handleResponse(),
                (error) => this.handleError(error, "alertShow", true)
              );
              break;
            case "edit":
              this.apiService
                .updateData("virtual-order", this.entity)
                .subscribe(
                  () => this.handleResponse(),
                  (error) => this.handleError(error, "alertShow", true)
                );
              break;
          }
          break;
        case "SAVE_NEW":
          this.apiService.addData("virtual-order", this.entity).subscribe(
            () => this.handleNew(),
            (error) => this.handleError(error, "alertShow", true)
          );
          break;
      }
    } else {
      this.handleError("required_fields_must_be_entered");
    }
  }

  handleResponse() {
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    if (this.tabId) {
      this.formChange(false);
      this.explorerService.closeTab(this.tabId);
    } else if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleNew() {
    this.alertShow = false;
    this.formChange(false);
    this.toastService.toastSuccess();
    this.clearForm();
  }

  handleError(error, errorType = "alertShow", commitError = false) {
    if (commitError) {
      if (this.linesCollectionView.sourceCollection) {
        if (this.linesCollectionView.sourceCollection.length === 0) {
          this.addNewLine();
        }
      }
      if (this.entity.virtual_order_lines) {
        if (this.entity.virtual_order_lines.length > 0) {
          for (let i = 0; i < this.entity.virtual_order_lines.length; i++) {
            if (this.entity.virtual_order_lines[i].rec_status) {
              // rec_status property'i varsa
              if (this.entity.virtual_order_lines[i].rec_status === "DELETE") {
                // mükerrer obje oluşmasın diye statusu DELETE olan kayıtlar siliniyor
                this.entity.virtual_order_lines.splice(i, 1);
                i = i - 1;
              }
            }
          }
        }
      }
    }
    this[errorType] = true;
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
  }

  unlockEntity() {
    this.apiService.unlockData("virtual-order", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    if (this.mode === "edit") {
      this.unlockEntity();
    }
    this.subscription.unsubscribe();
    this.subscriptionUserDetail.unsubscribe();
  }
}
